import axios from "axios";
import { API_BASE_URL } from "./api";

/**
 * Core API utility — /api/health and /api/declarations. Served by the Node backend today;
 * REACT_APP_CORE_API_URL can still point it at a separate service.
 */
const coreApi = axios.create({
    baseURL: process.env.REACT_APP_CORE_API_URL || API_BASE_URL,
});

// Request Interceptor: Add Auth headers if needed in future
coreApi.interceptors.request.use(
    (config) => {
        // Handle custom .NET JWT if implemented later
        return config;
    },
    (error) => Promise.reject(error)
);

export default coreApi;
